import React, { useEffect, useRef } from 'react';
import { SectionContainerLight } from '../common/sections/SectionContainerLight';
import { holdingPartnersImageSrc } from '@/constants';

export const SectionOurHoldingPartners: React.FC<{
  className?: string;
  scrollSpeed?: number;
}> = ({ className, scrollSpeed = 0.5 }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let frame: number;
    let accumulator = 0;

    const animateScroll = () => {
      if (!scrollContainer) return;

      accumulator += scrollSpeed;

      if (accumulator >= 1) {
        const move = Math.floor(accumulator);
        scrollContainer.scrollLeft += move;
        accumulator -= move;
      }

      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
        scrollContainer.scrollLeft = 0;
      }

      frame = requestAnimationFrame(animateScroll);
    };

    frame = requestAnimationFrame(animateScroll);

    return () => cancelAnimationFrame(frame);
  }, [scrollSpeed]);

  const chunkArray = (arr: string[], size: number) => {
    const result: string[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const logos = chunkArray([...holdingPartnersImageSrc, ...holdingPartnersImageSrc], 2);

  return (
    <SectionContainerLight
      id="holding-partners"
      additionalClassName={`!py-4 !mb-2 -mt-9 ${className ?? ''}`}
    >
      <div className="flex flex-col mx-auto text-center items-center mb-4 md:mb-8">
        <p className="text-black text-3xl md:text-4xl font-body font-semibold align-center mt-10">
          Our Holding Partners
        </p>
        <div className="border-2 md:border-4 border-accent-100 rounded-full w-40 mt-4 md:mt-6" />
      </div>

      {/* 🔹 Scroll Container */}
      <div ref={scrollRef} className="w-full overflow-x-auto scrollbar-hide">
        <div className="flex gap-6 px-6">
          {logos.map((pair, index) => (
            <div
              key={index}
              className="flex flex-col gap-8 my-4 flex-shrink-0 w-32 items-center justify-center"
            >
              {pair.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt="partner-logo"
                  className="max-h-20 object-contain"
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </SectionContainerLight>
  );
};
